<template>
  <transition name="fade">
    <div class="row" id="info-menu" @click="$router.back()">
      <div class="col-sm-8">
        <h4 v-text="$t('labels.menu')" v-if="currentDevice"></h4>

        <div class="list-group" v-if="currentDevice && isManager">
          <button type="button" class="list-group-item list-group-item-action" @click.stop="goToLastEntries">
            <h5 class="mb-0">
              <font-awesome-icon :icon="['fas', 'chess-clock']" class="mr-2" fixed-width/>
              {{ $t('labels.last_entries') }}
            </h5>
          </button>
        </div>

        <div class="list-group mt-2" v-if="currentDevice && currentDevice.register_activities && isManager">
          <button type="button" class="list-group-item list-group-item-action" @click.stop="goToActivities">
            <h5 class="mb-0">
              <font-awesome-icon :icon="['fas', 'tools']" class="mr-2" fixed-width/>
              {{ $t('labels.activities') }}
            </h5>
          </button>

          <button type="button" class="list-group-item list-group-item-action" @click.stop="goToRows">
            <h5 class="mb-0">
              <font-awesome-icon :icon="['fas', 'line-columns']" class="mr-2" fixed-width/>
              {{ $t('labels.rows') }}
            </h5>
          </button>

          <button type="button" class="list-group-item list-group-item-action" @click.stop="goToTeams">
            <h5 class="mb-0">
              <font-awesome-icon :icon="['fas', 'users']" class="mr-2" fixed-width/>
              {{ $t('labels.teams') }}
            </h5>
          </button>

          <button type="button" class="list-group-item list-group-item-action" @click.stop="goToSettings">
            <h5 class="mb-0">
              <font-awesome-icon :icon="['fas', 'screwdriver']" class="mr-2" fixed-width/>
              {{ $t('labels.settings') }}
            </h5>
          </button>
        </div>

        <div :class="'list-group' + isManager ? 'mt-2' : ''">
          <button type="button" class="list-group-item list-group-item-action" @click.stop="sync" v-if="currentDevice && online">
            <h5 class="mb-0">
              <font-awesome-icon :icon="['fas', 'sync']" class="mr-2" fixed-width/>
              {{ $t('labels.synchronise_settings') }}
            </h5>
          </button>
        </div>
      </div>

      <div class="col-sm-4 border-left">
        <h4 class="d-flex justify-content-between">
          {{ $t('labels.info') }}
          <font-awesome-icon :icon="['fas', 'times']"/>
        </h4>

        <dl class="dl-horizontal" v-if="currentDevice">
          <dt>{{ $t('labels.device_name') }}</dt>
          <dd>{{ this.$store.getters.currentDevice.name }}</dd>
          <dt>{{ $tc('labels.location', 1) }}</dt>
          <dd>{{ this.$store.getters.currentLocation.name }}</dd>
        </dl>

        <dl v-if="currentDevice">
          <dt>{{ $t('labels.registers') }}</dt>
          <dd>
            <span v-if="$store.getters.currentDevice.register_workdays">{{ $t('labels.workdays') }}<br/></span>
            <span v-if="$store.getters.currentDevice.register_activities">{{ $t('labels.activities') }}<br/></span>
            <span v-if="$store.getters.currentDevice.pre_register_activities">{{
                $t('labels.pre_registers')
              }}<br/></span>
          </dd>
        </dl>

        <dl class="dl-horizontal" v-if="currentDevice">
          <dt>{{ $t('labels.uuid') }}</dt>
          <dd>{{ this.currentDevice.uuid }}</dd>
        </dl>

        <dl class="dl-horizontal" v-if="currentDevice && ($store.getters.debug || $store.state.enableTracking)">
          <dt v-text="$t('labels.debug_and_tracking')"></dt>
          <dd>
            <span v-if="$store.getters.debug">Debug</span>
            <span v-if="$store.getters.debug && $store.state.enableTracking"> & </span>
            <span v-if="$store.state.enableTracking">Track</span>
          </dd>
        </dl>

        <dl>
          <dt v-text="$t('labels.version')"></dt>
          <dd v-text="$store.state.version"></dd>
        </dl>
      </div>
    </div>
  </transition>
</template>

<script>
import {writeTrackLog} from "../utils/tracking";
// import axios from "axios";
// import * as config from "../config/config";

export default {
  name: 'main-menu',

  data() {
    return {
      showInfo: false,
      syncing: false
    }
  },

  computed: {
    online() {
      return this.$store.state.online
    },

    currentDevice() {
      return this.$store.getters.currentDevice
    },

    currentLocation() {
      return this.$store.getters.currentLocation
    },

    currentEmployee() {
      return this.$store.getters.currentEmployee
    },

    isManager() {
      if (this.currentLocation && this.currentEmployee) {
        return this.currentLocation.managers.find((manager) => manager.id === this.currentEmployee.id);
      }
      return false
    }
  },

  methods: {
    goToActivities() {
      this.showInfo = false;
      this.$router.push({name: 'activities'});
    },

    goToLastEntries() {
      this.showInfo = false;
      this.$router.push({name: 'last-entries'});
    },

    goToRows() {
      this.showInfo = false;
      this.$router.push({name: 'rows'});
    },

    goToTeams() {
      this.showInfo = false;
      this.$router.push({name: 'teams'});
    },

    goToSettings() {
      this.showInfo = false;
      this.$router.push({name: 'settings'});
    },

    sync() {
      if (this.$store.getters.enableTracking) writeTrackLog("Sync triggered from menu");

      const self = this;
      self.syncing = true;
      this.$store.dispatch('syncResources', self);
    },
  },

  mounted() {
    const self = this;

    window.events.$emit('disableNumpad');

    let main = document.querySelector('.app-main');
    let sidebar = document.querySelector('.app-sidebar');

    main.classList.add('app-main--fullscreen');
    sidebar.style.display = 'none';

    window.events.$emit('setFullscreen', true);

    window.events.$on('synced', function () {
      self.syncing = false;
    });
  },

  beforeDestroy() {
    window.events.$emit('setFullscreen', false);

    let main = document.querySelector('.app-main');
    let sidebar = document.querySelector('.app-sidebar');

    main.classList.remove('app-main--fullscreen');
    sidebar.style.display = 'flex';
  }
}
</script>
